(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ap-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    var INIT = '_apCdInit';

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function setUnit(el, val) {
      var padded = pad(val);
      if (el.textContent === padded) return;
      el.textContent = padded;
      el.classList.remove('is-tick');
      // force reflow so the animation restarts
      void el.offsetWidth;
      el.classList.add('is-tick');
    }

    function update(root, target) {
      var now = Date.now();
      var diff = target - now;

      if (diff <= 0) {
        root.classList.add('is-expired');
        var exp = root.querySelector('.ap-cd__expired');
        if (exp) exp.removeAttribute('hidden');
        return true; // done
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      var s = Math.floor(diff / 1000) % 60;

      var days = root.querySelector('[data-unit="days"]');
      var hours = root.querySelector('[data-unit="hours"]');
      var mins = root.querySelector('[data-unit="minutes"]');
      var secs = root.querySelector('[data-unit="seconds"]');
      if (days) setUnit(days, d);
      if (hours) setUnit(hours, h);
      if (mins) setUnit(mins, m);
      if (secs) setUnit(secs, s);
      return false;
    }

    function init(root) {
      if (root[INIT]) return;
      root[INIT] = true;

      var raw = root.getAttribute('data-target');
      if (!raw) return;

      var target = new Date(raw).getTime();
      if (isNaN(target)) {
        // Invalid date — hide countdown gracefully
        root.style.display = 'none';
        return;
      }

      if (update(root, target)) return;

      var intervalId = setInterval(function () {
        if (update(root, target)) clearInterval(intervalId);
      }, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-ap-cd]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when the theme editor re-renders blocks
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ap-pack-selector"] && !Shopify.designMode) return;
  try {
    /* TODO: Appstle integration — this JS drives the quantity input, displayed
     prices, and the ATC button label. Appstle Bundles applies the actual
     tiered discount at checkout. Appstle Subscriptions may intercept the
     form submit and read quantity from its own field, so we also re-enforce
     quantity during the submit capture phase. */
  (function () {
    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findProductForm() {
      return (
        document.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('product-form-component form')
      );
    }

    function ensureQtyInput(form) {
      if (!form) return null;
      var input = form.querySelector('input[name="quantity"]');
      if (input) return input;
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      input.setAttribute('data-ap-packs-injected', '1');
      form.appendChild(input);
      return input;
    }

    function findQtyInput() {
  return (
    document.querySelector('product-form-component input[name="quantity"]') ||
    document.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]') ||
    ensureQtyInput(findProductForm())
  );
}

    function setQty(value) {
      var input = findQtyInput();
      if (!input) return null;
      var str = String(value);
      input.value = str;
      input.setAttribute('value', str);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return input;
    }

    /* --- Subscription-aware price sync ---------------------------------
       Keeps the Appstle widget's displayed prices (one-time + subscribe
       rows) and the ATC button in lockstep with the currently-selected
       pack qty. The subscription multiplier is read once from the
       widget's SAVE badge (e.g. "SAVE 12%") and cached.

       Appstle's own widget code re-renders the price spans to its base
       per-unit values whenever a radio in the widget changes. We layer
       a MutationObserver on top of the widget so that when Appstle
       clobbers our pack-adjusted totals, we reapply them on the next
       frame. A write-in-progress flag + value-equality check prevents
       observer loops. ----------------------------------------------- */
    var apSubMult = null;
    var apWriteFlag = false;
    var apRafPending = false;
    var apAtcLockTimer = null;

    function isFiniteNum(n) {
      return typeof n === 'number' && isFinite(n);
    }

    /* --- ATC transition lock ------------------------------------------
       Every pack/plan change briefly disables the main and sticky ATC
       buttons so a rapid second click can't race ahead of the qty +
       selling_plan sync. Visual: a gentle pulse. Pointer events are
       blocked via CSS (pointer-events:none) and keyboard clicks are
       blocked via a capture-phase listener further down.
    ----------------------------------------------------------------- */
    function atcButtons() {
      return document.querySelectorAll('.add-to-cart-button, .sticky-atc__button');
    }

    function lockAtc(ms) {
      var duration = isFiniteNum(ms) && ms > 0 ? ms : 300;
      atcButtons().forEach(function (btn) {
        btn.setAttribute('data-ap-busy', '1');
      });
      if (apAtcLockTimer) clearTimeout(apAtcLockTimer);
      apAtcLockTimer = setTimeout(unlockAtc, duration);
    }

    function unlockAtc() {
      if (apAtcLockTimer) {
        clearTimeout(apAtcLockTimer);
        apAtcLockTimer = null;
      }
      atcButtons().forEach(function (btn) {
        btn.removeAttribute('data-ap-busy');
      });
    }

    /* Block keyboard-initiated clicks (Enter / Space) while busy, since
       pointer-events:none only stops mouse/touch. Capture phase so we
       run before Horizon's submit handler. */
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest
          ? event.target.closest('.add-to-cart-button, .sticky-atc__button')
          : null;
        if (btn && btn.getAttribute('data-ap-busy') === '1') {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;
        var atc = form.querySelector('.add-to-cart-button');
        if (atc && atc.getAttribute('data-ap-busy') === '1') {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    /* Returns a subscription price multiplier in (0, 1], or 1 if the
       widget is absent / has no subscribe option / can't be parsed.
       A mult of 1 means "subscribed price == one-time price", which is
       the safe no-op behaviour for products without a selling plan. */
    function readSubMultiplier() {
      if (apSubMult !== null) return apSubMult;
      var widget = document.querySelector('.appstle_sub_widget');
      if (!widget) return 1;
      var badge = widget.querySelector('.appstle-save-badge');
      if (badge && badge.textContent) {
        var m = badge.textContent.match(/(\d+(?:\.\d+)?)\s*%/);
        if (m) {
          var pct = parseFloat(m[1]);
          if (isFiniteNum(pct) && pct >= 0 && pct < 100) {
            apSubMult = 1 - pct / 100;
            return apSubMult;
          }
        }
      }
      var subAmt = widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount');
      var subCmp = widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount');
      if (subAmt && subCmp) {
        var s = parseFloat(String(subAmt.textContent || '').replace(/[^\d.]/g, ''));
        var c = parseFloat(String(subCmp.textContent || '').replace(/[^\d.]/g, ''));
        if (isFiniteNum(s) && isFiniteNum(c) && c > 0 && s > 0 && s <= c) {
          apSubMult = s / c;
          return apSubMult;
        }
      }
      /* Don't cache 1 — we want to retry once the widget actually
         renders its content. Callers get 1 as a safe fallback in
         the meantime. */
      return 1;
    }

    /* True only when the widget exists AND a subscribe plan radio is
       currently checked with a non-empty value. Products without a
       selling plan return false, which keeps the effective price as
       the plain pack total. */
    function isAppstleSubscribed() {
      var checked = document.querySelector('.appstle_sub_widget input[type="radio"][name="selling_plan"]:checked');
      return !!(checked && checked.value);
    }

    function syncAppstleAndAtc(packTotalCents) {
      if (!isFiniteNum(packTotalCents)) return;

      var mult = readSubMultiplier();
      if (!isFiniteNum(mult) || mult <= 0 || mult > 1) mult = 1;
      var subTotal = Math.round(packTotalCents * mult);

      apWriteFlag = true;
      var widget = document.querySelector('.appstle_sub_widget');
      if (widget) {
        var oneAmt = widget.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount');
        var subAmt = widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount');
        var subCmp = widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount');
        var oneText = money(packTotalCents);
        var subText = money(subTotal);
        if (oneAmt && oneAmt.textContent !== oneText) oneAmt.textContent = oneText;
        if (subAmt && subAmt.textContent !== subText) subAmt.textContent = subText;
        if (subCmp && subCmp.textContent !== oneText) subCmp.textContent = oneText;
      }

      var effective = isAppstleSubscribed() ? subTotal : packTotalCents;
      if (!isFiniteNum(effective)) effective = packTotalCents;
      var effectiveMoney = money(effective);

      var atcLabel = document.querySelector('.add-to-cart-button .add-to-cart-text__content');
      if (atcLabel) {
        var atcText = 'Add to cart \u00B7 ' + effectiveMoney;
        if (atcLabel.textContent !== atcText) atcLabel.textContent = atcText;
      }
      var stickyPrice = document.querySelector('.sticky-atc__price');
      if (stickyPrice && stickyPrice.textContent !== effectiveMoney) {
        stickyPrice.textContent = effectiveMoney;
      }
      setTimeout(function () { apWriteFlag = false; }, 0);
    }

    function currentPackTotalCents() {
      var active = document.querySelector('[data-ap-packs] .ap-pk.is-on');
      if (!active) return null;
      var wrap = active.closest('[data-ap-packs]');
      if (!wrap) return null;
      var base = parseInt(wrap.dataset.basePrice, 10);
      if (!isFiniteNum(base) || base < 0) return null;
      var q = parseInt(active.dataset.qty, 10);
      if (!isFiniteNum(q) || q <= 0) q = 1;
      var d = parseInt(active.dataset.disc, 10);
      if (!isFiniteNum(d) || d < 0 || d >= 100) d = 0;
      var unit = Math.round(base * (1 - d / 100));
      if (!isFiniteNum(unit) || unit < 0) return null;
      return unit * q;
    }

    function refreshPrices() {
      var t = currentPackTotalCents();
      if (t != null) syncAppstleAndAtc(t);
    }

    function init() {
      document.querySelectorAll('[data-ap-packs]').forEach(function (wrap) {
        if (wrap.dataset.apPacksInit === '1') return;
        wrap.dataset.apPacksInit = '1';

        var base = parseInt(wrap.dataset.basePrice, 10);
        var cards = wrap.querySelectorAll('.ap-pk');

        function calc(card) {
          var q = parseInt(card.dataset.qty, 10) || 1;
          var d = parseInt(card.dataset.disc, 10) || 0;
          var unit = Math.round(base * (1 - d / 100));
          return { q: q, unit: unit, total: unit * q };
        }

        function pick(card, opts) {
          cards.forEach(function (c) {
            c.classList.remove('is-on');
            c.setAttribute('aria-pressed', 'false');
          });
          card.classList.add('is-on');
          card.setAttribute('aria-pressed', 'true');

          var info = calc(card);
          var totalText = money(info.total);
          var unitText = money(info.unit) + ' each';

          var totalEl = card.querySelector('[data-pk-total]');
          var unitEl = card.querySelector('[data-pk-unit]');
          if (totalEl) totalEl.textContent = totalText;
          if (unitEl) unitEl.textContent = unitText;

          setQty(info.q);
          syncAppstleAndAtc(info.total);
          if (!(opts && opts.silent)) lockAtc(300);

          document.dispatchEvent(
            new CustomEvent('ap:pack-change', {
              detail: {
                quantity: info.q,
                total: info.total,
                unit: info.unit,
                totalText: totalText,
                silent: !!(opts && opts.silent),
              },
            })
          );
        }

        cards.forEach(function (c) {
          var info = calc(c);
          var totalEl = c.querySelector('[data-pk-total]');
          var unitEl = c.querySelector('[data-pk-unit]');
          if (totalEl) totalEl.textContent = money(info.total);
          if (unitEl) unitEl.textContent = money(info.unit) + ' each';
          c.addEventListener('click', function () {
            pick(c);
          });
        });

        var def = wrap.querySelector('.ap-pk.is-on') || cards[0];
        if (def) pick(def, { silent: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    function ensureSellingPlanInput(form) {
      var input = form.querySelector('input[name="selling_plan"]');
      if (input) return input;
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = '';
      input.setAttribute('data-ap-packs-injected', '1');
      form.appendChild(input);
      return input;
    }

    function readAppstlePlanId() {
      /* The top-level selling_plan radios (one-time + each plan) share
         name="selling_plan" and are the authoritative source of truth.
         A nested "selling_plan_radio" (inside the expanded subscribe
         panel) is always checked within its own group, so the old
         any-checked-radio scan returned the plan ID even after the
         user switched back to one-time. Scope the lookup to the
         primary group and fall back to selects. */
      var widget = document.querySelector('.appstle_sub_widget');
      if (!widget) return '';

      var primary = widget.querySelector('input[type="radio"][name="selling_plan"]:checked');
      if (primary) return primary.value || '';

      var select = widget.querySelector('select[name="selling_plan"]');
      if (select) return select.value || '';

      return '';
    }

    function syncSellingPlanToForms() {
      var planId = readAppstlePlanId();
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
        var input = form.querySelector('input[name="selling_plan"]');
        if (!input) input = ensureSellingPlanInput(form);
        if (input.getAttribute('data-ap-packs-injected') === '1') {
          input.value = planId;
        }
      });
    }

    document.addEventListener(
      'change',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (!t.closest('.appstle_sub_widget, [class*="appstle_subscription"], [id*="appstle"]')) return;
        syncSellingPlanToForms();
        refreshPrices();
        lockAtc(300);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (!t.closest('.appstle_sub_widget, [class*="appstle_subscription"], [id*="appstle"]')) return;
        lockAtc(300);
        setTimeout(function () {
          syncSellingPlanToForms();
          refreshPrices();
        }, 0);
      },
      true
    );

    /* Appstle's widget renders asynchronously after our JS runs, so its
       default per-unit prices won't match the default pack total until
       the user interacts. Watch for the widget to appear, then do a
       one-shot sync. Observer disconnects on first success or after
       15s as a safety cap. */
    function attachPriceObserver(widget) {
      if (!widget || widget.dataset.apPriceObs === '1') return;
      widget.dataset.apPriceObs = '1';
      var obs = new MutationObserver(function () {
        if (apWriteFlag || apRafPending) return;
        apRafPending = true;
        requestAnimationFrame(function () {
          apRafPending = false;
          if (apWriteFlag) return;
          var total = currentPackTotalCents();
          if (total == null) return;
          var oneAmt = widget.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount');
          if (!oneAmt) return;
          var shown = Math.round(parseFloat(String(oneAmt.textContent || '').replace(/[^\d.]/g, '')) * 100);
          if (!isFiniteNum(shown) || Math.abs(shown - total) > 1) {
            syncAppstleAndAtc(total);
          }
        });
      });
      obs.observe(widget, { childList: true, subtree: true, characterData: true });
    }

    function waitForAppstleAndSync() {
  var widget = document.querySelector('.appstle_sub_widget');
  if (!widget || widget.dataset.apPriceSynced === '1') return false;
  var badge = widget.querySelector('.appstle-save-badge');
  if (badge && !(badge.textContent || '').trim()) return false;
  widget.dataset.apPriceSynced = '1';
  syncSellingPlanToForms();
  refreshPrices();
  attachPriceObserver(widget);
  unlockAtc();
  return true;
}

    /* Appstle loads asynchronously. We try a short burst of scheduled
       checks, then fall back to a bounded body-wide observer. For
       products with no selling plan the widget never appears — we
       time-bound the observer so we don't leak an open observer. The
       pack-driven ATC + sticky sync still works without it because
       pick() and the pack click listener call refreshPrices directly. */
    if (!waitForAppstleAndSync()) {
      /* If this product has selling plans, briefly lock ATC so users
         can't submit before Appstle's widget finishes attaching its
         listeners. unlockAtc() fires inside waitForAppstleAndSync()
         as soon as the widget is synced, or the lock auto-releases
         at the safety cap. Products without plans skip the lock. */
      var wrapEl = document.querySelector('[data-ap-packs]');
      if (wrapEl && wrapEl.dataset.hasPlans === '1') {
        lockAtc(1500);
      }

      var apCheckTimers = [300, 900, 2500];
      apCheckTimers.forEach(function (ms) {
        setTimeout(waitForAppstleAndSync, ms);
      });

      var apObs = new MutationObserver(function () {
        if (waitForAppstleAndSync()) apObs.disconnect();
      });
      try {
        apObs.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { apObs.disconnect(); }, 8000);
      } catch (_) { /* body not ready yet — the timers above still cover it */ }
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;

        var active = document.querySelector('[data-ap-packs] .ap-pk.is-on');
        if (active) {
          var q = parseInt(active.dataset.qty, 10);
          if (q) {
            var qInput = form.querySelector('input[name="quantity"]') || ensureQtyInput(form);
            if (qInput) {
              qInput.value = String(q);
              qInput.setAttribute('value', String(q));
            }
          }
        }

        var planInput = form.querySelector('input[name="selling_plan"]');
        if (!planInput) planInput = ensureSellingPlanInput(form);
        if (planInput.getAttribute('data-ap-packs-injected') === '1') {
          planInput.value = readAppstlePlanId();
        }
      },
      true
    );
  })();

/* Az utolsó védvonal: bármilyen módon épül fel a FormData
   (submit, Horizon AJAX, sticky ATC), itt írjuk felül
   a quantity-t és a selling_plan-t. */
document.addEventListener('formdata', function (event) {
  var form = event.target;
  if (!form || !form.matches ||
      !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;

  var fd = event.formData;

  var active = document.querySelector('[data-ap-packs] .ap-pk.is-on');
  if (active) {
    var q = parseInt(active.dataset.qty, 10);
    if (q > 0) fd.set('quantity', String(q));
  }

  if (document.querySelector('.appstle_sub_widget')) {
    var plan = readAppstlePlanId();
    if (plan) fd.set('selling_plan', plan);
    else fd.delete('selling_plan');
  }
});
  } catch(e) { console.error(e); }
})();

})();
